import { createSearchParams, type SearchParams } from '~/stores/main'
import { storeToRefs } from 'pinia'

const searchParamKeys = Object.keys(createSearchParams()) as Array<keyof SearchParams>

function extractSearchParams(query: any) {
  return searchParamKeys.reduce((result, key) => {
    if (query[key] !== undefined) {
      result[key] = query[key]
    }
    return result
  }, {} as any)
}

function searchParamsFromLocationQuery(query: any): SearchParams {
  const result = createSearchParams()

  for (const key of searchParamKeys) {
    if (query[key] === undefined) {
      continue
    }

    if (key === 'search_for_arrival' || key === 'only_regional' || key === 'bike') {
      result[key] = query[key] === 'true'
    } else if (key === 'transfer_time') {
      result[key] = Number(query[key])
    } else {
      result[key] = String(query[key])
    }
  }

  return result
}

export default defineNuxtRouteMiddleware(async (to, from) => {
  const oldQueryParams = extractSearchParams(from.query)
  const newQueryParams = extractSearchParams(to.query)
  const newQueryParamsParsed = searchParamsFromLocationQuery(newQueryParams)

  const store = useMainStore()
  const { searchParams, stations } = storeToRefs(store)

  if (
    Object.keys(newQueryParams).length > 0 &&
    JSON.stringify(newQueryParams) !== JSON.stringify(oldQueryParams) &&
    JSON.stringify(newQueryParamsParsed) !== JSON.stringify(searchParams.value)
  ) {
    searchParams.value = newQueryParamsParsed
    if (to.path === '/journey-search-result') {
      await store.fetchStations()
      if (
        stations.value.includes(searchParams.value.start) &&
        stations.value.includes(searchParams.value.destination)
      ) {
        await store.getJourneys()
      } else {
        return navigateTo({
          path: to.path,
          query: to.query,
          hash: '#search'
        })
      }
    }
  } else if (Object.keys(newQueryParams).length === 0 && Object.keys(oldQueryParams).length > 0) {
    return navigateTo({
      path: to.path,
      query: oldQueryParams
    })
  }
})
